<template>
  <div class="pg-share">
    <div class="bg"></div>
    <div class="logo"></div>
    <div class="scroll-wrapper">
      <div class="scroll">
        <div>{{nickname}}</div>
      </div>
    </div>
    <div class="friend">
      <div class="prize-wrapper">
        <Prize
          v-for="(prize, index) in myPrize"
          :key="index"
          :prize="prize.icon"
          :name="prize.title"
        >
        </Prize>
      </div>
    </div>
    <!-- <div class="human"></div> -->
    <div v-if="showHelp" class="help" @click="help"></div>
    <div v-else class="draw" @click="goHome"></div>
    <a v-if="!ingame" class="btn-download ios" ref="ios" @click="iosHandler"></a>
    <a class="btn-download android" ref="android" @click="downloadHandler"></a>
  </div>
</template>
<script>
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import Prize from "~/components/Prize/index.vue";
import { isWeiXin, getParameterByName, isAndroid } from "~/tools/utils";
import api from "~/api/api";
import { mapState } from "vuex";
import Alert from "~/components/Alert";
import Help from "~/components/Help";

export default {
  components: {Prize},
  data() {
    return {
      isAndroid: isAndroid(),
      myPrize: [],
      fid: getParameterByName("fid"),
      wxtitle: "邀你助力《原始征途》终极测试福利五十连抽",
      wxdesc: "老史送豪礼，终极五十连抽！时装礼包、专属称号、升星宝石……助你终极测试战力飞升！",
      wximages: "https://" + window.location.host + "/act/blc/share.jpg",
      loading: false,
      nickname: '',
      invite_state: 0,
      help_state: 0,
      ingame: getParameterByName("ingame")
    }
  },
  mounted() {
    // TODO 测试助力弹窗 需去掉
    // Help("助力成功！<br>你也去抽个十连试试手气吧！").then(() => {
    //   this.$router.push('/index')
    // });

    const _this = this;
    var appid = 'wx0fcf7f47419c8171';

    requirejs(["weixin/main", "downloadway/main", "jquery"],function(weixin, Download, $){
    // requirejs(["downloadway/main", "jquery"],function(Download, $){
      Promise.all([
        api.getUserInfo(),
        api.getFriendPrize(_this.fid)
      ]).then(res => {
        if(res[1] && res[1].status === 1) {
          _this.myPrize = res[1].data.item_detail;
          _this.nickname = _this.getChineseChar(res[1].nickname);
          _this.invite_state = res[1].invite_state
        }
        if(res[0].status === 1) {
          store.commit(types.UPDATE_USER, res[0]);
          _this.help_state = res[0].help_state
          if(res[0].weixin_state) {
            window.wx = new weixin(appid,() => {
              //朋友圈
              wx.onMenuShareTimeline({
                  title: `${res[0].shareinfo.nickname}邀你助力《原始征途》终极测试福利五十连抽`, // 分享标题
                  link: window.location.origin + `/act/blc/#/share?fid=${res[0].shareinfo.userid}`, // 分享链接
                  imgUrl: _this.wximages
              });
              //朋友
              wx.onMenuShareAppMessage({
                  title: `${res[0].shareinfo.nickname}邀你助力《原始征途》终极测试福利五十连抽`, // 分享标题
                  desc: _this.wxdesc, // 分享描述
                  link: window.location.origin + `/act/blc/#/share?fid=${res[0].shareinfo.userid}`, // 分享链接
                  imgUrl: _this.wximages, // 分享图标
                  type: 'link' // 分享类型,music、video或link，不填默认为link
              });
              if(_this.ingame) {
                window.wx.miniProgram.postMessage({data: { fid: res.shareinfo.userid }});
              }
            });
          } else {
            window.wx = new weixin(appid,() => {
              //朋友圈
              wx.onMenuShareTimeline({
                  title: `${res[0].shareinfo.nickname}邀你助力《原始征途》终极测试福利五十连抽`, // 分享标题
                  link: window.location.href, // 分享链接
                  imgUrl: _this.wximages
              });
              //朋友
              wx.onMenuShareAppMessage({
                  title: `${res[0].shareinfo.nickname}邀你助力《原始征途》终极测试福利五十连抽`, // 分享标题
                  desc: _this.wxdesc, // 分享描述
                  link: window.location.href, // 分享链接
                  imgUrl: _this.wximages, // 分享图标
                  type: 'link' // 分享类型,music、video或link，不填默认为link
              });
            });
          }
          if(res[0].shareinfo.userid === parseInt(_this.fid)) {
            // _this.$router.replace('/index')
            window.location.replace(location.origin + location.pathname)
          }
        }
        store.commit(types.SHOW_LOADING, false);
        if(localStorage.getItem('toHelp')) {
          _this.help();
        }
      });
      if(!_this.ingame) {
        new Download({
          iosBtn: $(".ios"),
            androidBtn: $(".android"),
          display: "block",
          tip: "iOS版本敬请期待",
          callback: function (info) {},
        });
      }
    });
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    }),
    showHelp() {
      return !this.invite_state && !this.help_state
    }
  },
  methods: {
    iosHandler() {
      _paq.push(['trackEvent', 'BLC-Download', 'Share', 'ios', 'ios'])
    },
    downloadHandler() {
      let platform = this.isAndroid ? 'android' : 'ios'
      _paq.push(['trackEvent', 'BLC-Download', 'Share', platform, platform])
      if(this.ingame) {
        let url = `https://yszt.ztgame.com/download/${platform}.html`
        store.commit(types.SHOW_MODAL, {type: 'copy', copy: url})
      }
    },
    checkLoginStatus() {
      if(!this.userInfo.weixin_state) {
        localStorage.setItem('toHelp', true)
        let url = `/act/blc/api/api.php?c=index&a=wxauth&fid=${this.fid}`
        if(this.ingame) {
          url += '&ingame=ingame'
        }
        location.replace(url)
        return false;
      }
      return true
    },
    help() {
      if(!this.checkLoginStatus()) {
        return
      }
      if(this.loading) {
        return
      }
      store.commit(types.SHOW_LOADING, true)
      this.loading = true;
      api.helpFriend(this.fid, this.userInfo.shareinfo.userid).then(res => {
        if(res.status === 1) {
          Help("助力成功！<br>你也去抽个十连试试手气吧！").then(() => {
            // this.$router.push('/index')
            window.location.replace(location.origin + location.pathname)
          });
        }
        localStorage.removeItem('toHelp')
        store.commit(types.SHOW_LOADING, false)
        this.loading = false;
      }).catch(() => {
        localStorage.removeItem('toHelp')
        store.commit(types.SHOW_LOADING, false)
        this.loading = false;
      })
    },
    getChineseChar(value) {
      var l = 0;
      let output = ''
      if (value) {
        Array.from({ length: value.length }, (v, i) => {
          if (/[\u4e00-\u9fa5]/.test(value[i])) {
            l += 2;
          } else {
            l += 1;
          }
        });
      }
      if(l > 14) {
        output = value.substr(0, 12) + '...'
      } else {
        output = value.substr(0, 14)
      }
      return output;
    },
    goHome() {
      // this.$router.push('/index')
      window.location.replace(location.origin + location.pathname)
    },
  }
}
</script>

<style lang="stylus" scoped>
  .pg-share
    width 100%
    min-height 100vh
    background url('./images/friend-bg.png')
    background-repeat no-repeat
    background-size 7.5rem 13.34rem
    background-color #440101
    .prize-wrapper
      margin 1.46rem 0 0 0.58rem;
      display flex
      flex-wrap wrap
    .logo
      position absolute
      top 0.18rem
      left 0.17rem
      width 2.27rem
      height 0.94rem
      background:url(./images/logo.png) no-repeat;
      background-size contain
    .scroll-wrapper
      position absolute
      top 1.23rem
      left 4.54rem
      width 2.84rem
      height 0.62rem
      .scroll
        width 2.84rem
        height 0.62rem
        background:url(./images/scroll.png) no-repeat;
        background-size contain
        font-size 0.28rem
        color: #fff
        line-height 0.66rem
        text-align center
        letter-spacing 0.01rem
        font-weight bold
        word-break break-all
        display flex
        flex-direction column
        justify-content center
        align-items center
        padding: 0 0.2rem
      .slogan
        position absolute
        bottom 0
        left 0.29rem
        width 2.37rem
        height 2.35rem
        background:url(./images/friend-slogan.png) no-repeat;
        background-size contain
        animation slideInRight 0.6s ease
    .human
      position absolute
      top 0.16rem
      left 3.28rem
      width 4.22rem
      height 5.47rem
      background:url(./images/human.png) no-repeat;
      background-size contain
    .friend
      position absolute
      top 6.93rem
      left 0.3rem
      width 6.91rem
      height 5.24rem
      background:url(./images/friend-prize.png) no-repeat;
      background-size contain
    .help
      position absolute
      top 6.68rem
      left 50%
      margin-left -1.4rem
      width 2.8rem
      height 1rem
      background:url(./images/help.png) no-repeat;
      background-size contain
      animation: shake 2.4s both infinite;
    .draw
      position absolute
      left 50%
      margin-left -1.4rem
      top 6.68rem
      width 2.8rem
      height 1rem
      background:url(./images/me.png) no-repeat;
      background-size contain
      animation: shake 2.4s both infinite;
    .btn-download
      position absolute
      top 12.38rem
      left 50%
      margin-left -1.325rem
      width 2.65rem
      height 0.7rem
      background:url(./images/download2.png) no-repeat;
      background-size contain
@keyframes rotate {
  to {
    transform: rotateY(360deg)
  }
}
@keyframes rotate {
  to {
    transform: rotateY(360deg)
  }
}
@keyframes slideInRight {
  0% {
    opacity: 0
    transform: translateX(100%)
  }

  100% {
    opacity: 1
    transform: translateX(0)
  }
}

@keyframes shake {
  5%,
  10% {
    transform: scale(0.9) rotate(-3deg);
  }

  15%,
  25%,
  35%,
  45% {
    transform: scale(1.1) rotate(3deg);
  }

  20%,
  30%,
  40% {
    transform: scale(1.1) rotate(-3deg);
  }

  50% {
    transform: scale(1) rotate(0);
  }
}
</style>
